import React, { useState } from "react";
import { Card, Form, Table } from "react-bootstrap";
import UseToggle from "../../../Hooks/UseToggle";
import ToolBar from "../ToolBar";
import { TbListDetails } from "react-icons/tb";
import { AiOutlineForm } from "react-icons/ai";
import { GrDocumentPerformance } from "react-icons/gr";
import FormDetails from "./FormDetails";
import FormEditor from "./FormEditor";
import FormDataEntry from "./FormDataEntry";

const formsData = [
  {
    id: 1,
    name: "Customer Feedback",
    createdAt: "2025-01-12 10:45 AM",
    updatedAt: "2025-02-03 04:20 PM",
    url: "https://forms.app/customer-feedback",
    status: "Active",
  },
  {
    id: 2,
    name: "Employee Survey",
    createdAt: "2025-01-18 02:30 PM",
    updatedAt: "2025-02-01 11:10 AM",
    url: "https://forms.app/employee-survey",
    status: "Inactive",
  },
  {
    id: 3,
    name: "Event Registration",
    createdAt: "2025-01-05 09:15 AM",
    updatedAt: "2025-02-06 06:40 PM",
    url: "https://forms.app/event-registration",
    status: "Active",
  },
  {
    id: 4,
    name: "Product Order",
    createdAt: "2025-01-22 01:00 PM",
    updatedAt: "2025-02-04 08:25 AM",
    url: "https://forms.app/product-order",
    status: "Active",
  },
  {
    id: 5,
    name: "Support Request",
    createdAt: "2025-01-28 05:10 PM",
    updatedAt: "2025-02-07 09:55 AM",
    url: "https://forms.app/support-request",
    status: "Inactive",
  },
  {
    id: 6,
    name: "Job Application",
    createdAt: "2025-01-15 11:40 AM",
    updatedAt: "2025-02-05 03:30 PM",
    url: "https://forms.app/job-application",
    status: "Active",
  },
  {
    id: 7,
    name: "Website Audit",
    createdAt: "2025-02-01 10:20 AM",
    updatedAt: "2025-02-07 12:15 PM",
    url: "https://forms.app/website-audit",
    status: "Draft",
  },
  {
    id: 8,
    name: "Newsletter Signup",
    createdAt: "2025-01-01 08:00 AM",
    updatedAt: "2025-02-06 07:45 PM",
    url: "https://forms.app/newsletter-signup",
    status: "Active",
  },
  {
    id: 9,
    name: "Lead Capture",
    createdAt: "2025-01-19 04:55 PM",
    updatedAt: "2025-02-02 10:05 AM",
    url: "https://forms.app/lead-capture",
    status: "Paused",
  },
  {
    id: 10,
    name: "Course Enrollment",
    createdAt: "2025-01-08 12:35 PM",
    updatedAt: "2025-02-05 05:50 PM",
    url: "https://forms.app/course-enrollment",
    status: "Active",
  },
];

const FormManagement = ({}) => {
  const toggles = UseToggle();
  const [selected, setSelected] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [openHistory, setOpenHistory] = useState("details");
  const [search, setSearch] = useState("");
  const [checkedIds, setCheckedIds] = useState([]);

  const filteredFormsData = formsData.filter((item) => {
    const q = search.toLowerCase();

    return (
      item.name?.toLowerCase().includes(q) ||
      item.email?.toLowerCase().includes(q) ||
      item.phone?.includes(q) ||
      item.organization?.toLowerCase().includes(q)
    );
  });

  const toggleSingle = (id) => {
    setCheckedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (checkedIds.length === formsData.length) {
      setCheckedIds([]);
    } else {
      setCheckedIds(formsData.map((c) => c.id));
    }
  };

  const isAllChecked =
    formsData.length > 0 && checkedIds.length === formsData.length;
  const isChecked = (id) => checkedIds.includes(id);

  const pageSize = 50;
  const [page, setPage] = useState(1);

  const totalItems = filteredFormsData.length;
  const totalPages = Math.ceil(totalItems / pageSize);

  const paginatedFormsData = filteredFormsData.slice(
    (page - 1) * pageSize,
    page * pageSize,
  );

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  return (
    <>
      <ToolBar
        toggles={toggles}
        search={search}
        setSearch={setSearch}
        checkedIds={checkedIds}
        setCheckedIds={setCheckedIds}
        showPreview={showPreview}
        setShowPreview={setShowPreview}
        setSelected={setSelected}
        start={start}
        end={end}
        totalItems={totalItems}
        page={page}
        setPage={setPage}
        totalPages={totalPages}
        addField
        editField
      />
      <div className={`contacts-layout ${showPreview ? "with-preview" : ""}`}>
        <div
          className={`table-section overflow-auto bg-white ${showPreview ? "border-end" : ""}`}
          style={{ height: "calc(100vh - 50px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>Form Name</div>
                  </div>
                </th>
                {!selected && (
                  <>
                    <th>Generated Date | Time</th>
                    <th>Modified Date | Time</th>
                    <th>Form URL</th>
                    <th>Status</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {paginatedFormsData.map((form) => (
                <tr
                  key={form.id}
                  className={`contact-row ${selected?.id === form.id ? "active" : ""}`}
                  onClick={() => {
                    setSelected(form);
                    setShowPreview(true);
                  }}
                >
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(form.id)}
                          onChange={() => toggleSingle(form.id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div className="fw-medium">{form.name}</div>
                    </div>
                  </td>

                  {!selected && (
                    <>
                      <td>{form.createdAt}</td>
                      <td>{form.updatedAt}</td>
                      <td>
                        <a
                          href={form.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                        >
                          {form.url}
                        </a>
                      </td>
                      <td>
                        <span
                          className={`badge ${form.status === "Active" ? "bg-success" : form.status === "Inactive" ? "bg-secondary" : form.status === "Paused" ? "bg-warning text-dark" : "bg-info"}`}
                        >
                          {form.status}
                        </span>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <div className={`preview-section ${showPreview ? "open" : ""}`}>
          {selected && (
            <>
              <div className="preview-switcher">
                <button
                  className={`hstack gap-2 justify-content-center ${openHistory === "details" && "active"}`}
                  onClick={() => setOpenHistory("details")}
                >
                  <TbListDetails /> Details
                </button>
                <button
                  className={`hstack gap-2 justify-content-center ${openHistory === "formEditor" && "active"}`}
                  onClick={() => setOpenHistory("formEditor")}
                >
                  <AiOutlineForm /> Form Editor
                </button>
                <button
                  className={`hstack gap-2 justify-content-center ${openHistory === "formEntry" && "active"}`}
                  onClick={() => setOpenHistory("formEntry")}
                >
                  <GrDocumentPerformance /> Form Preview
                </button>
              </div>
              <div className={`overflow-auto w-100`} style={{ height: "calc(100vh - 97px)" }}>
                <Card className="border-0 rounded-0 h-100">
                  <Card.Body className="p-0 d-flex flex-column">
                    <div className="preview-scroll p-0">
                      {openHistory === "details" && (
                        <div className="preview-block">
                          <FormDetails selected={selected} />
                        </div>
                      )}
                      {openHistory === "formEditor" && (
                        <div className="preview-block">
                          <FormEditor setOpenHistory={setOpenHistory} />
                        </div>
                      )}
                      {openHistory === "formEntry" && (
                        <div className="preview-block">
                          <FormDataEntry selected={selected} />
                        </div>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default FormManagement;
